import React, { useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { motion, useInView } from 'framer-motion';
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';

const GradientText = ({ children }) => (
  <Typography
    variant="h2"
    sx={{
      fontWeight: 'bold',
      fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2rem' },
      textAlign: 'center',
      background: 'linear-gradient(to right, #e65100, #ff781f)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      mb: 2,
      lineHeight: 1.2,
    }}
  >
    {children}
  </Typography>
);

const GradientStrong = ({ children }) => (
  <Box
    component="span"
    sx={{
      background: 'linear-gradient(to right, #e65100, #ff781f )',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 'bold',
    }}
  >
    {children}
  </Box>
);

const PromoWeb = () => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const inView1 = useInView(ref1, { once: true, margin: '-100px' });
  const inView2 = useInView(ref2, { once: true, margin: '-100px' });

  return (
    <Box sx={{ px: 2, py: 6, maxWidth: '900px', mx: 'auto' }}>
      <motion.div
        ref={ref1}
        initial={{ opacity: 0, y: 60 }}
        animate={inView1 ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <Box textAlign="center" mb={10}>
          <GradientText>
            ¿Buscas atención <br /> personalizada?
          </GradientText>

          <Typography variant="body1" sx={{ mb: 4, color: '#333', fontSize: '1.1rem' }}>
            Ofrecemos instalación de antivirus, mantenimiento de computadoras, asesoría en venta de equipos,
            recuperación de datos y más. Recibe una atención directa y especializada. También puedes seguirnos
            en redes sociales y comunicarte con nosotros por el canal que prefieras.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 3,
              mt: 4,
              fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2rem' },
            }}
          >
            <Box
              component="a"
              href="https://www.facebook.com/cmsoltec/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              sx={{
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.1)',
                },
              }}
            >
              <FaFacebookF style={{ color: '#1877f2' }} />
            </Box>

            <Box
              component="a"
              href="https://www.instagram.com/cmsoltec/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              sx={{
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.1)',
                },
              }}
            >
              <FaInstagram style={{ color: '#e4405f' }} />
            </Box>

            <Box
              component="a"
              href="https://www.tiktok.com/@cmsoltec?lang=es"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              sx={{
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.1)',
                },
              }}
            >
              <FaTiktok style={{ color: '#000000' }} />
            </Box>

            <Box
              component="a"
              href="https://api.whatsapp.com/send?phone=593984813777"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              sx={{
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.1)',
                },
              }}
            >
              <FaWhatsapp style={{ color: '#25D366' }} />
            </Box>
          </Box>
        </Box>
      </motion.div>

      <motion.div
        ref={ref2}
        initial={{ opacity: 0, scale: 0.85 }}
        animate={inView2 ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.9, ease: 'easeOut' }}
      >
        <Box textAlign="center">
          <GradientText>
            ¿Deseas crear tu propia <br /> página web?
          </GradientText>

          <Button
            variant="outlined"
            href="https://api.whatsapp.com/send?phone=593984813777&text=Hola%2C%20deseo%20crear%20mi%20p%C3%A1gina%20web%20personalizada"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
                backgroundColor: "#e65100",
                color: "#fff",
                fontWeight: "bold",
                fontSize: { xs: "0.9rem", sm: "1rem" },
                border: "#e65100",
                px: 4,
                py: 1.2,
                mt: 2,
                mb: 4,
                alignSelf: "flex-start",
                borderRadius: "30px",
                boxShadow: "0 6px 12px rgba(0,0,0,0.35)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#ff781f",
                  border: "#ff781f ",
                },
              }}
          >
            Contáctanos
          </Button>

          <Typography variant="body1" sx={{ color: '#333', fontSize: '1.1rem' }}>
            Somos expertos en desarrollo de páginas web a medida y tiendas online optimizadas para buscadores
            como Google. Trabajamos con <GradientStrong>Django</GradientStrong> y {' '}
            <GradientStrong>React</GradientStrong>, frameworks modernos
            para soluciones efectivas.
          </Typography>
        </Box>
      </motion.div>
    </Box>
  );
};

export default PromoWeb;
